import React from 'react';
import { Radio as AntRadio } from 'antd';
import type { RadioProps, RadioGroupProps } from 'antd';
import { StyledRadio, StyledRadioGroup } from './styles';

type Compound = React.FC<RadioProps> & {
    Group: React.FC<RadioGroupProps>;
    Button: typeof AntRadio.Button;
};

const Radio = ((props) => <StyledRadio {...props} />) as Compound;

Radio.Group = (props) => <StyledRadioGroup {...props} />;
Radio.Button = AntRadio.Button;

export default Radio;
